<div fxLayout="column"
  *ngIf="{ associateDropdowns: data.associateDropdowns$ | async, addressDropdowns: data.addressDropdowns$ | async, locations:  data.locations$ | async} as data;">
  <h2 class="font-medium">Create A Customer</h2>
  <h3 class="font-medium">Associate </h3>
  <form *ngIf="associateForm" fxLayout="row wrap" fxLayoutAlign="start center" autocomplete="dank"
    [formGroup]="associateForm">

    <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex="33" fxFlex.lt-sm="100">
      <mat-form-field appearance="fill">
        <mat-label>Name (Last, First)</mat-label>
        <input #associateName matInput autocomplete="dank" id="dank" aria-label="Associate" formControlName="name"
          (keyup)="associateName.value=makeUpperCase(associateName.value)">
      </mat-form-field>
    </div>

    <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex="33" fxFlex.lt-sm="100">
      <mat-form-field appearance="fill">
        <mat-label>Email Address</mat-label>
        <input id="emailAddress" matInput formControlName="emailAddress">
        <mat-error *ngIf="associateForm.get('emailAddress').errors">
          {{associateForm.get('emailAddress').errors | inputError}}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex="33" fxFlex.lt-sm="100">
      <mat-form-field appearance="fill">
        <mat-label>Message Preference</mat-label>
        <mat-select name="messagePreferenceId" formControlName="messagePreferenceId">
          <mat-option *ngFor="let messageType of data.associateDropdowns.messageTypes" [value]="messageType.id">
            {{messageType.description}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex="33" fxFlex.lt-sm="100">
      <mat-form-field appearance="fill">
        <mat-label>Associate Class</mat-label>
        <mat-select name="classId" formControlName="classId">
          <mat-option *ngFor="let associateClass of data.associateDropdowns.associateClasses | orderBy: 'name'"
            [value]="associateClass.id">
            {{associateClass.name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>

  <h3 class="font-medium">Address </h3>
  <form *ngIf="addressForm" id="addressForm" fxLayout="row wrap" [formGroup]="addressForm" novalidate>
    <div class="form-field" fxLayoutAlign="center center" fxFlex="66" fxFlex.xs="100">
      <mat-form-field appearance="fill" class="w-95">
        <mat-label>Address Line</mat-label>
        <input id="addressLine1" matInput formControlName="addressLine1" #addressLine1 autocomplete="addressAuto"
          [matAutocomplete]="addressAuto">
        <mat-autocomplete #addressAuto="matAutocomplete" autocomplete="addressAuto"
          (optionSelected)="selectAddress($event.option.value, data.addressDropdowns)">
          <mat-option *ngFor="let address of addressPredictions" [value]="address">
            <span>{{address.description}}</span>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <div class="form-field" fxLayoutAlign="center center" fxFlex="33" fxFlex.lt-sm="100">
      <mat-form-field appearance="fill">
        <mat-label>Province/State</mat-label>
        <mat-select name="provStateId" formControlName="provStateId">
          <mat-option *ngFor="let provinceState of data.addressDropdowns.provinceStates" [value]="provinceState.id"
            (click)="setCountryCode(provinceState)">
            {{ provinceState.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="form-field" fxLayoutAlign="center center" fxFlex="33" fxFlex.lt-sm="100">
      <mat-form-field appearance="fill">
        <mat-label>Location</mat-label>
        <input #locationName matInput autocomplete="locationAuto" id="locationAuto" aria-label="Location"
          [matAutocomplete]="locationAuto" formControlName="locationId">
        <mat-autocomplete #locationAuto="matAutocomplete" autocomplete="locationAuto"
          [displayWith]="displayLocationName">

          <mat-option *ngFor="let location of filteredLocations$ | async" [value]="location"
            (click)="setPostalCodeAndProvince(location)">
            <span>{{location.description}} {{location.provStateId}}, {{location.countryId}}</span>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <div class="form-field" fxLayoutAlign="center center" fxFlex="33" fxFlex.lt-sm="100">
      <mat-form-field appearance="fill">
        <mat-label>Postal/Zip Code</mat-label>
        <input id="postalZipCode" matInput formControlName="postalZipCode">
      </mat-form-field>
    </div>

    <div class="form-field" fxLayoutAlign="center center" fxFlex="33" fxFlex.lt-sm="100">
      <mat-form-field appearance="fill">
        <mat-label>Cell Phone #</mat-label>
        <input #cellPhoneNumber id="cellPhoneNumber" matInput [textMask]="{mask: phoneNumberMask, guide: true}"
          formControlName="cellPhoneNumber">
        <mat-error *ngIf="addressForm.get('cellPhoneNumber').errors">
          {{addressForm.get('cellPhoneNumber').errors | inputError}}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-field" fxLayoutAlign="center center" fxFlex="33" fxFlex.lt-sm="100">
      <mat-form-field appearance="fill">
        <mat-label>Home Phone #</mat-label>
        <input id="homePhoneNumber" matInput [textMask]="{mask: phoneNumberMask, guide: true}"
          formControlName="homePhoneNumber">
      </mat-form-field>
    </div>

    <div fxFlex="100" fxLayout="row" fxLayoutAlign="end center">
      <button mat-button [mat-dialog-close]="null">Cancel</button>
      <button mat-button color="primary" [disabled]="!createReady"
        (click)="onSubmit(associateForm.getRawValue(),addressForm.getRawValue())">Create</button>
    </div>
  </form>
</div>